class EngravingCustomizer {
  constructor() {
    this.elements = [];
    this.selectedElement = null;
    this.draggedElement = null;
    this.dragOffset = { x: 0, y: 0 };
    this.isDragging = false;
    this.fonts = [
      'Arial', 
      'Times New Roman', 
      'Courier New', 
      'Georgia', 
      'Verdana', 
      'Comic Sans MS', 
      'Impact', 
      'Brush Script MT'
    ];
    this.engravingPrice = 0;
    this.isOpen = false;
    this.textUpdateTimeout = null;
    this.productImageUrl = '';
    this.productImageLoaded = false;
    
    console.log('✓ EngravingCustomizer initialized');
  }

  init(price, productImage) {
    console.log('✓ Init called with price:', price, 'image:', productImage);
    this.engravingPrice = parseFloat(price || 0);
    this.productImageUrl = productImage || '';
    this.createPopup();
    this.setupEventListeners();
    if (this.productImageUrl) {
      this.loadProductImage();
    }
    console.log('✓ Setup complete');
  }

  loadProductImage() {
    const canvas = this.canvas;
    if (!canvas) return;

    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      canvas.style.backgroundImage = `url(${this.productImageUrl})`;
      canvas.style.backgroundSize = 'contain';
      canvas.style.backgroundPosition = 'center';
      canvas.style.backgroundRepeat = 'no-repeat';
      this.productImageLoaded = true;
      console.log('✓ Product image loaded');
    };
    img.onerror = () => {
      console.error('Failed to load product image');
      this.productImageLoaded = false;
    };
    img.src = this.productImageUrl;
  }

  createPopup() {
    const existing = document.getElementById('engraving-popup');
    if (existing) {
      existing.remove();
    }

    const popup = document.createElement('div');
    popup.id = 'engraving-popup';
    popup.className = 'engraving-popup';
    popup.innerHTML = `
      <div class="engraving-popup-overlay"></div>
      <div class="engraving-popup-content">
        <div class="engraving-popup-header">
          <h2 class="engraving-popup-title">Customize Your Product</h2>
          <button type="button" class="engraving-popup-close" id="close-popup-btn">✕</button>
        </div>
        
        <div class="engraving-popup-body">
          <div class="engraving-container">
            <div class="engraving-canvas-wrapper">
              <div id="engraving-canvas" class="engraving-canvas">
                <div class="canvas-placeholder">
                  <p>Click "Add Text" or "Add Logo" to start customizing</p>
                </div>
              </div>
              
              <div class="engraving-controls">
                <button type="button" id="add-text-btn" class="engraving-btn engraving-btn-primary">
                  ✏️ Add Text
                </button>
                
                <button type="button" id="add-logo-btn" class="engraving-btn engraving-btn-success">
                  🖼️ Add Logo
                </button>
                
                <input type="file" id="logo-upload" accept="image/jpeg,image/png,image/gif,image/svg+xml" style="display:none;">
                
                <button type="button" id="delete-element-btn" class="engraving-btn engraving-btn-danger" style="display:none;">
                  🗑️ Delete
                </button>
              </div>
              
              <div id="engraving-price-display" style="display:none;"></div>
            </div>
            
            <div class="engraving-properties-wrapper">
              <h3 class="properties-title">Properties</h3>
              <div id="engraving-properties">
                <p style="color:#999; font-size:14px;">Select an element to edit</p>
              </div>
              
              <div class="engraving-instructions">
                <h4 class="instructions-title">💡 How to Use:</h4>
                <ul>
                  <li>Click "Add Text" to add custom text</li>
                  <li>Click text/logo on canvas to select it</li>
                  <li>Drag selected items to move them</li>
                  <li>Edit text in the properties panel →</li>
                  <li>Use sliders to adjust size and rotation</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        
        <div class="engraving-popup-footer">
          <button type="button" id="clear-all-btn" class="engraving-btn-secondary">Clear All</button>
          <button type="button" id="save-customization-btn" class="engraving-btn-save">Save & Continue</button>
        </div>
      </div>
    `;
    
    document.body.appendChild(popup);
    
    this.popup = popup;
    this.canvas = document.getElementById('engraving-canvas');
    this.propertiesPanel = document.getElementById('engraving-properties');
    
    console.log('✓ Popup created');
  }

  setupEventListeners() {
    const openBtn = document.getElementById('open-customizer-btn');
    if (openBtn) {
      openBtn.addEventListener('click', () => {
        console.log('✓ Open button clicked');
        this.openPopup();
      });
    }

    const closeBtn = document.getElementById('close-popup-btn');
    const overlay = document.querySelector('.engraving-popup-overlay');
    
    if (closeBtn) {
      closeBtn.addEventListener('click', () => this.closePopup());
    }
    if (overlay) {
      overlay.addEventListener('click', () => this.closePopup());
    }

    const addTextBtn = document.getElementById('add-text-btn');
    const addLogoBtn = document.getElementById('add-logo-btn');
    const logoUpload = document.getElementById('logo-upload');
    const deleteBtn = document.getElementById('delete-element-btn');
    const clearBtn = document.getElementById('clear-all-btn');
    const saveBtn = document.getElementById('save-customization-btn');

    if (addTextBtn) {
      addTextBtn.addEventListener('click', () => {
        console.log('✓ Add text clicked');
        this.addText();
      });
    }
    
    if (addLogoBtn) {
      addLogoBtn.addEventListener('click', () => {
        if (logoUpload) logoUpload.click();
      });
    }
    
    if (logoUpload) {
      logoUpload.addEventListener('change', (e) => this.addLogo(e));
    }
    
    if (deleteBtn) {
      deleteBtn.addEventListener('click', () => this.deleteElement());
    }
    
    if (clearBtn) {
      clearBtn.addEventListener('click', () => this.clearAll());
    }
    
    if (saveBtn) {
      saveBtn.addEventListener('click', () => this.saveAndClose());
    }

    if (this.canvas) {
      this.canvas.addEventListener('mousedown', (e) => {
        if (e.target === this.canvas || e.target.classList.contains('canvas-placeholder')) {
          this.selectedElement = null;
          this.render();
        }
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen) {
          this.closePopup();
        }
      });
    }

    console.log('✓ Event listeners attached');
  }

  openPopup() {
    if (this.popup) {
      this.popup.classList.add('active');
      document.body.style.overflow = 'hidden';
      this.isOpen = true;
      this.render();
      this.updatePriceDisplay();
      console.log('✓ Popup opened');
    }
  }

  closePopup() {
    if (this.popup) {
      this.popup.classList.remove('active');
      document.body.style.overflow = '';
      this.isOpen = false;
      console.log('✓ Popup closed');
    }
  }

  addText() {
    const newText = {
      id: 'text-' + Date.now(),
      type: 'text',
      content: 'Your Text Here',
      x: 150,
      y: 150,
      fontSize: 24,
      fontFamily: 'Arial',
      color: '#000000',
      rotation: 0
    };
    
    this.elements.push(newText);
    this.selectedElement = newText.id;
    this.render();
    this.updatePriceDisplay();
    this.updateButton();
    
    console.log('✓ Text added:', newText);
  }

  addLogo(e) {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.type.startsWith('image/')) {
      alert('Please upload a valid image file (JPG, PNG, GIF, SVG)');
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      alert('Image size must be less than 5MB');
      return;
    }
    
    const reader = new FileReader();
    reader.onload = (event) => {
      const newLogo = {
        id: 'logo-' + Date.now(),
        type: 'logo',
        src: event.target.result,
        x: 100,
        y: 100,
        width: 100,
        height: 100,
        rotation: 0
      };
      
      this.elements.push(newLogo);
      this.selectedElement = newLogo.id;
      this.render();
      this.updatePriceDisplay();
      this.updateButton();
      
      console.log('✓ Logo added');
    };
    reader.readAsDataURL(file);
    
    e.target.value = '';
  }

  deleteElement() {
    if (this.selectedElement) {
      this.elements = this.elements.filter(el => el.id !== this.selectedElement);
      this.selectedElement = null;
      this.render();
      this.updatePriceDisplay();
      this.updateButton();
      console.log('✓ Element deleted');
    }
  }

  clearAll() {
    if (this.elements.length > 0) {
      if (confirm('Are you sure you want to clear all elements?')) {
        this.elements = [];
        this.selectedElement = null;
        this.render();
        this.updatePriceDisplay();
        this.updateButton();
        console.log('✓ All cleared');
      }
    }
  }

  updateElement(id, updates) {
    const element = this.elements.find(el => el.id === id);
    if (element) {
      Object.assign(element, updates);
      this.render();
    }
  }

  render() {
    if (!this.canvas) return;

    this.canvas.innerHTML = '';

    if (this.elements.length === 0) {
      const placeholder = document.createElement('div');
      placeholder.className = 'canvas-placeholder';
      placeholder.innerHTML = '<p>Click "Add Text" or "Add Logo" to start customizing</p>';
      this.canvas.appendChild(placeholder);
      this.updatePropertiesPanel();
      return;
    }

    this.elements.forEach(element => {
      const wrapper = document.createElement('div');
      wrapper.className = 'canvas-element';
      wrapper.dataset.elementId = element.id;
      wrapper.style.position = 'absolute';
      wrapper.style.left = element.x + 'px';
      wrapper.style.top = element.y + 'px';
      wrapper.style.transform = `rotate(${element.rotation}deg)`;
      wrapper.style.cursor = 'move';
      wrapper.style.userSelect = 'none';

      if (this.selectedElement === element.id) {
        wrapper.style.outline = '2px solid #3b82f6';
        wrapper.style.outlineOffset = '2px';
        wrapper.style.zIndex = '100';
      }

      if (element.type === 'text') {
        const textDiv = document.createElement('div');
        textDiv.textContent = element.content;
        textDiv.style.fontSize = element.fontSize + 'px';
        textDiv.style.fontFamily = element.fontFamily;
        textDiv.style.color = element.color;
        textDiv.style.whiteSpace = 'nowrap';
        textDiv.style.lineHeight = '1';
        textDiv.style.pointerEvents = 'none';
        wrapper.appendChild(textDiv);
      } else {
        const img = document.createElement('img');
        img.src = element.src;
        img.style.width = element.width + 'px';
        img.style.height = element.height + 'px';
        img.style.objectFit = 'contain';
        img.style.pointerEvents = 'none';
        img.draggable = false;
        wrapper.appendChild(img);
      }

      this.attachDragHandlers(wrapper, element);

      this.canvas.appendChild(wrapper);
    });

    this.updatePropertiesPanel();
  }

  attachDragHandlers(wrapper, element) {
    let startX, startY, initialX, initialY;

    const onMouseDown = (e) => {
      e.stopPropagation();
      
      this.selectedElement = element.id;
      this.render();

      this.isDragging = true;
      startX = e.clientX;
      startY = e.clientY;
      initialX = element.x;
      initialY = element.y;

      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);

      console.log('✓ Drag started');
    };

    const onMouseMove = (e) => {
      if (!this.isDragging) return;

      const dx = e.clientX - startX;
      const dy = e.clientY - startY;

      const newX = Math.max(0, Math.min(initialX + dx, this.canvas.offsetWidth - 50));
      const newY = Math.max(0, Math.min(initialY + dy, this.canvas.offsetHeight - 50));

      this.updateElement(element.id, { x: newX, y: newY });
    };

    const onMouseUp = () => {
      this.isDragging = false;
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
      console.log('✓ Drag ended');
    };

    wrapper.addEventListener('mousedown', onMouseDown);

    wrapper.addEventListener('touchstart', (e) => {
      e.preventDefault();
      const touch = e.touches[0];
      onMouseDown({ clientX: touch.clientX, clientY: touch.clientY, stopPropagation: () => e.stopPropagation() });
    });

    wrapper.addEventListener('touchmove', (e) => {
      e.preventDefault();
      if (!this.isDragging) return;
      const touch = e.touches[0];
      onMouseMove({ clientX: touch.clientX, clientY: touch.clientY });
    });

    wrapper.addEventListener('touchend', () => {
      onMouseUp();
    });
  }

  updatePropertiesPanel() {
    const panel = this.propertiesPanel;
    if (!panel) return;

    const selected = this.elements.find(el => el.id === this.selectedElement);
    const deleteBtn = document.getElementById('delete-element-btn');

    if (!selected) {
      panel.innerHTML = '<p style="color:#999; font-size:14px;">Select an element on canvas to edit its properties</p>';
      if (deleteBtn) deleteBtn.style.display = 'none';
      return;
    }

    if (deleteBtn) deleteBtn.style.display = 'flex';

    let html = '';

    if (selected.type === 'text') {
      html = `
        <div class="property-group">
          <label class="property-label">Text Content</label>
          <textarea id="text-content-input" class="property-input" rows="3" maxlength="100" placeholder="Enter your text here...">${selected.content}</textarea>
          <span class="property-hint"><span id="char-count">${selected.content.length}</span>/100 characters</span>
        </div>
        
        <div class="property-group">
          <label class="property-label">Font Family</label>
          <select id="font-family-select" class="property-input">
            ${this.fonts.map(font => `<option value="${font}" ${selected.fontFamily === font ? 'selected' : ''}>${font}</option>`).join('')}
          </select>
        </div>
        
        <div class="property-group">
          <label class="property-label">Font Size: <span id="font-size-display">${selected.fontSize}</span>px</label>
          <input type="range" id="font-size-slider" min="12" max="72" value="${selected.fontSize}" class="property-slider">
        </div>
        
        <div class="property-group">
          <label class="property-label">Text Color</label>
          <input type="color" id="text-color-picker" value="${selected.color}" class="property-color">
        </div>
      `;
    } else {
      html = `
        <div class="property-group">
          <label class="property-label">Logo Size</label>
          <div style="display:flex; gap:10px;">
            <button type="button" id="resize-smaller-btn" class="property-btn">- Smaller</button>
            <button type="button" id="resize-larger-btn" class="property-btn">+ Larger</button>
          </div>
        </div>
      `;
    }

    html += `
      <div class="property-group">
        <label class="property-label">Rotation: <span id="rotation-display">${selected.rotation}</span>°</label>
        <input type="range" id="rotation-slider" min="0" max="360" value="${selected.rotation}" class="property-slider">
      </div>
      
      <div class="property-info">
        Position: X: ${Math.round(selected.x)}px, Y: ${Math.round(selected.y)}px
      </div>
    `;

    panel.innerHTML = html;

    setTimeout(() => this.attachPropertyListeners(selected), 0);
  }

  attachPropertyListeners(selected) {
    if (selected.type === 'text') {
      const textInput = document.getElementById('text-content-input');
      const fontSelect = document.getElementById('font-family-select');
      const sizeSlider = document.getElementById('font-size-slider');
      const colorPicker = document.getElementById('text-color-picker');
      const charCount = document.getElementById('char-count');
      const sizeDisplay = document.getElementById('font-size-display');

      if (textInput) {
        textInput.addEventListener('input', (e) => {
          const value = e.target.value;
          if (value.length <= 100) {
            if (this.textUpdateTimeout) {
              clearTimeout(this.textUpdateTimeout);
            }
            
            this.updateElement(selected.id, { content: value });
            
            if (charCount) {
              charCount.textContent = value.length;
            }
          } else {
            e.target.value = value.substring(0, 100);
          }
        });

        textInput.addEventListener('keydown', (e) => {
          e.stopPropagation();
        });

        textInput.addEventListener('click', (e) => {
          e.stopPropagation();
        });
      }

      if (fontSelect) {
        fontSelect.addEventListener('change', (e) => {
          this.updateElement(selected.id, { fontFamily: e.target.value });
        });
      }

      if (sizeSlider) {
        sizeSlider.addEventListener('input', (e) => {
          if (sizeDisplay) sizeDisplay.textContent = e.target.value;
          this.updateElement(selected.id, { fontSize: parseInt(e.target.value) });
        });
      }

      if (colorPicker) {
        colorPicker.addEventListener('input', (e) => {
          this.updateElement(selected.id, { color: e.target.value });
        });
      }
    } else {
      const smallerBtn = document.getElementById('resize-smaller-btn');
      const largerBtn = document.getElementById('resize-larger-btn');

      if (smallerBtn) {
        smallerBtn.addEventListener('click', () => {
          this.updateElement(selected.id, {
            width: Math.max(30, selected.width - 20),
            height: Math.max(30, selected.height - 20)
          });
        });
      }

      if (largerBtn) {
        largerBtn.addEventListener('click', () => {
          this.updateElement(selected.id, {
            width: Math.min(300, selected.width + 20),
            height: Math.min(300, selected.height + 20)
          });
        });
      }
    }

    const rotationSlider = document.getElementById('rotation-slider');
    const rotationDisplay = document.getElementById('rotation-display');

    if (rotationSlider) {
      rotationSlider.addEventListener('input', (e) => {
        if (rotationDisplay) rotationDisplay.textContent = e.target.value;
        this.updateElement(selected.id, { rotation: parseInt(e.target.value) });
      });
    }
  }

  updatePriceDisplay() {
    const priceDisplay = document.getElementById('engraving-price-display');
    if (priceDisplay) {
      if (this.elements.length > 0 && this.engravingPrice > 0) {
        priceDisplay.innerHTML = `<strong>+$${this.engravingPrice.toFixed(2)}</strong> for custom engraving`;
        priceDisplay.style.display = 'block';
      } else {
        priceDisplay.style.display = 'none';
      }
    }
  }

  updateButton() {
    const openBtn = document.getElementById('open-customizer-btn');
    if (openBtn) {
      if (this.elements.length > 0) {
        openBtn.innerHTML = `✏️ Edit Customization (${this.elements.length} item${this.elements.length > 1 ? 's' : ''})`;
        openBtn.classList.add('has-customization');
      } else {
        openBtn.innerHTML = '✨ Customize This Product';
        openBtn.classList.remove('has-customization');
      }
    }
  }

  // FIXED: Proper async image loading for canvas capture
  async captureCanvasAsImage() {
    return new Promise((resolve) => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      
      canvas.width = 800;
      canvas.height = 600;

      // Background color
      ctx.fillStyle = '#f3f4f6';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      const scaleX = canvas.width / this.canvas.offsetWidth;
      const scaleY = canvas.height / this.canvas.offsetHeight;

      // Load product image first
      if (this.productImageUrl && this.productImageLoaded) {
        const productImg = new Image();
        productImg.crossOrigin = 'anonymous';
        
        productImg.onload = () => {
          // Draw product image
          const scale = Math.min(canvas.width / productImg.width, canvas.height / productImg.height);
          const x = (canvas.width - productImg.width * scale) / 2;
          const y = (canvas.height - productImg.height * scale) / 2;
          ctx.drawImage(productImg, x, y, productImg.width * scale, productImg.height * scale);
          
          // Now draw all elements
          this.drawAllElements(ctx, scaleX, scaleY, resolve, canvas);
        };
        
        productImg.onerror = () => {
          console.error('Failed to load product image for canvas');
          this.drawAllElements(ctx, scaleX, scaleY, resolve, canvas);
        };
        
        productImg.src = this.productImageUrl;
      } else {
        this.drawAllElements(ctx, scaleX, scaleY, resolve, canvas);
      }
    });
  }

  // FIXED: Draw all elements including logos with proper async handling
  async drawAllElements(ctx, scaleX, scaleY, resolve, canvas) {
    const textElements = this.elements.filter(el => el.type === 'text');
    const logoElements = this.elements.filter(el => el.type === 'logo');

    // Draw text elements (synchronous)
    textElements.forEach(element => {
      ctx.save();
      ctx.translate(element.x * scaleX, element.y * scaleY);
      ctx.rotate((element.rotation * Math.PI) / 180);
      ctx.font = `${element.fontSize * Math.min(scaleX, scaleY)}px ${element.fontFamily}`;
      ctx.fillStyle = element.color;
      ctx.textBaseline = 'top';
      ctx.fillText(element.content, 0, 0);
      ctx.restore();
    });

    // Draw logo elements (asynchronous)
    if (logoElements.length === 0) {
      resolve(canvas.toDataURL('image/png'));
      return;
    }

    let loadedLogos = 0;
    const totalLogos = logoElements.length;

    logoElements.forEach(element => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      
      img.onload = () => {
        ctx.save();
        ctx.translate(
          element.x * scaleX + (element.width * scaleX) / 2,
          element.y * scaleY + (element.height * scaleY) / 2
        );
        ctx.rotate((element.rotation * Math.PI) / 180);
        ctx.drawImage(
          img,
          -(element.width * scaleX) / 2,
          -(element.height * scaleY) / 2,
          element.width * scaleX,
          element.height * scaleY
        );
        ctx.restore();
        
        loadedLogos++;
        if (loadedLogos === totalLogos) {
          resolve(canvas.toDataURL('image/png'));
        }
      };
      
      img.onerror = () => {
        console.error('Failed to load logo for canvas');
        loadedLogos++;
        if (loadedLogos === totalLogos) {
          resolve(canvas.toDataURL('image/png'));
        }
      };
      
      img.src = element.src;
    });
  }

  async captureTextLayerOnly() {
    return new Promise((resolve) => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      
      canvas.width = 800;
      canvas.height = 600;

      ctx.clearRect(0, 0, canvas.width, canvas.height);

      const scaleX = canvas.width / this.canvas.offsetWidth;
      const scaleY = canvas.height / this.canvas.offsetHeight;

      const textElements = this.elements.filter(el => el.type === 'text');
      
      textElements.forEach(element => {
        ctx.save();
        ctx.translate(element.x * scaleX, element.y * scaleY);
        ctx.rotate((element.rotation * Math.PI) / 180);
        ctx.font = `${element.fontSize * Math.min(scaleX, scaleY)}px ${element.fontFamily}`;
        ctx.fillStyle = element.color;
        ctx.textBaseline = 'top';
        ctx.fillText(element.content, 0, 0);
        ctx.restore();
      });
      
      resolve(canvas.toDataURL('image/png'));
    });
  }

  async captureLogoLayerOnly() {
    return new Promise((resolve) => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      
      canvas.width = 800;
      canvas.height = 600;

      ctx.clearRect(0, 0, canvas.width, canvas.height);

      const scaleX = canvas.width / this.canvas.offsetWidth;
      const scaleY = canvas.height / this.canvas.offsetHeight;

      const logoElements = this.elements.filter(el => el.type === 'logo');
      
      if (logoElements.length === 0) {
        resolve(canvas.toDataURL('image/png'));
        return;
      }

      let loadedLogos = 0;
      const totalLogos = logoElements.length;

      logoElements.forEach(element => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        
        img.onload = () => {
          ctx.save();
          ctx.translate(
            element.x * scaleX + (element.width * scaleX) / 2,
            element.y * scaleY + (element.height * scaleY) / 2
          );
          ctx.rotate((element.rotation * Math.PI) / 180);
          ctx.drawImage(
            img,
            -(element.width * scaleX) / 2,
            -(element.height * scaleY) / 2,
            element.width * scaleX,
            element.height * scaleY
          );
          ctx.restore();
          
          loadedLogos++;
          if (loadedLogos === totalLogos) {
            resolve(canvas.toDataURL('image/png'));
          }
        };
        
        img.onerror = () => {
          console.error('Failed to load logo for layer');
          loadedLogos++;
          if (loadedLogos === totalLogos) {
            resolve(canvas.toDataURL('image/png'));
          }
        };
        
        img.src = element.src;
      });
    });
  }

  async saveAndClose() {
    if (this.elements.length === 0) {
      alert('Please add at least one text or logo element before saving.');
      return;
    }

    // Show loading message
    const loadingMsg = document.createElement('div');
    loadingMsg.className = 'engraving-success-message show';
    loadingMsg.innerHTML = '⏳ Processing images... Please wait';
    document.body.appendChild(loadingMsg);

    try {
      const engravingData = await this.getEngravingData();
      
      // Upload images to Shopify and get URLs
      loadingMsg.innerHTML = '📤 Uploading preview image...';
      const previewUrl = await this.uploadImageToShopify(engravingData.previewImage, 'preview');
      
      loadingMsg.innerHTML = '📤 Uploading text layer...';
      const textLayerUrl = await this.uploadImageToShopify(engravingData.textLayerImage, 'text-layer');
      
      loadingMsg.innerHTML = '📤 Uploading logo layer...';
      const logoLayerUrl = await this.uploadImageToShopify(engravingData.logoLayerImage, 'logo-layer');
      
      // Set form fields with URLs instead of base64
      const dataField = document.getElementById('engraving-data');
      const textField = document.getElementById('engraving-text');
      const logoField = document.getElementById('logo-data');
      const priceField = document.getElementById('engraving-price-value');
      const summaryField = document.getElementById('engraving-summary');
      const previewField = document.getElementById('engraving-preview');
      const textImageField = document.getElementById('engraving-text-image');
      const logoImageField = document.getElementById('engraving-logo-image');

      if (dataField) dataField.value = engravingData.fullData;
      if (textField) textField.value = engravingData.textSummary;
      if (logoField) logoField.value = engravingData.logoSummary;
      if (priceField) priceField.value = engravingData.price.toFixed(2);
      if (summaryField) summaryField.value = engravingData.readableSummary;
      if (previewField) previewField.value = previewUrl;
      if (textImageField) textImageField.value = textLayerUrl;
      if (logoImageField) logoImageField.value = logoLayerUrl;

      loadingMsg.remove();
      this.closePopup();
      this.updateButton();
      this.showSuccessMessage();
      
      console.log('✓ Customization saved with uploaded images');
    } catch (error) {
      console.error('Error saving customization:', error);
      loadingMsg.innerHTML = '❌ Error saving. Please try again.';
      setTimeout(() => loadingMsg.remove(), 3000);
    }
  }

  async uploadImageToShopify(base64Data, filename) {
    if (!base64Data || base64Data === '' || base64Data.length < 100) {
      return '';
    }

    try {
      // Convert base64 to blob
      const blob = await fetch(base64Data).then(r => r.blob());
      
      // Create form data
      const formData = new FormData();
      formData.append('file', blob, `engraving-${filename}-${Date.now()}.png`);
      formData.append('filename', `engraving-${filename}-${Date.now()}.png`);
      
      // Upload to Netlify function
      const response = await fetch('/.netlify/functions/upload-engraving', {
        method: 'POST',
        body: formData
      });
      
      if (!response.ok) {
        throw new Error('Upload failed');
      }
      
      const data = await response.json();
      return data.url; // Return Shopify CDN URL
      
    } catch (error) {
      console.error('Upload error:', error);
      // Fallback to base64 if upload fails
      return base64Data;
    }
  }

  showSuccessMessage() {
    const message = document.createElement('div');
    message.className = 'engraving-success-message';
    message.innerHTML = '✓ Customization saved! Add to cart when ready.';
    document.body.appendChild(message);

    setTimeout(() => message.classList.add('show'), 100);
    setTimeout(() => {
      message.classList.remove('show');
      setTimeout(() => message.remove(), 300);
    }, 3000);
  }

  async getEngravingData() {
    const textElements = this.elements.filter(el => el.type === 'text');
    const logoElements = this.elements.filter(el => el.type === 'logo');

    let readableSummary = '=== ENGRAVING CUSTOMIZATION ===\n\n';
    
    if (textElements.length > 0) {
      readableSummary += '📝 TEXT ELEMENTS:\n';
      textElements.forEach((t, index) => {
        readableSummary += `\n${index + 1}. "${t.content}"\n`;
        readableSummary += `   Font: ${t.fontFamily}\n`;
        readableSummary += `   Size: ${t.fontSize}px\n`;
        readableSummary += `   Color: ${t.color}\n`;
        readableSummary += `   Position: X=${Math.round(t.x)}px, Y=${Math.round(t.y)}px\n`;
        readableSummary += `   Rotation: ${t.rotation}°\n`;
      });
    }
    
    if (logoElements.length > 0) {
      readableSummary += '\n\n🖼️ LOGO ELEMENTS:\n';
      logoElements.forEach((l, index) => {
        readableSummary += `\n${index + 1}. Logo Image\n`;
        readableSummary += `   Size: ${l.width}x${l.height}px\n`;
        readableSummary += `   Position: X=${Math.round(l.x)}px, Y=${Math.round(l.y)}px\n`;
        readableSummary += `   Rotation: ${l.rotation}°\n`;
      });
    }
    
    readableSummary += '\n\n💰 ENGRAVING PRICE: $' + this.engravingPrice.toFixed(2);

    const previewImage = await this.captureCanvasAsImage();
    const textLayerImage = await this.captureTextLayerOnly();
    const logoLayerImage = await this.captureLogoLayerOnly();

    return {
      hasEngraving: true,
      elementCount: this.elements.length,
      texts: textElements.map(t => ({
        content: t.content,
        font: t.fontFamily,
        size: t.fontSize,
        color: t.color,
        position: { x: t.x, y: t.y },
        rotation: t.rotation
      })),
      logos: logoElements.map(l => ({
        size: { width: l.width, height: l.height },
        position: { x: l.x, y: l.y },
        rotation: l.rotation
      })),
      fullData: JSON.stringify(this.elements),
      textSummary: textElements.length > 0 ? textElements.map(t => t.content).join(', ') : 'No text',
      logoSummary: logoElements.length > 0 ? `${logoElements.length} logo(s) uploaded` : 'No logo',
      readableSummary: readableSummary,
      price: this.engravingPrice,
      previewImage: previewImage,
      textLayerImage: textLayerImage,
      logoLayerImage: logoLayerImage
    };
  }
}

window.initEngravingCustomizer = function(price, productImage) {
  console.log('=== INITIALIZING CUSTOMIZER ===');
  console.log('Price:', price);
  console.log('Product Image:', productImage);
  
  if (!window.engravingCustomizer) {
    window.engravingCustomizer = new EngravingCustomizer();
    console.log('✓ New instance created');
  }
  
  window.engravingCustomizer.init(price, productImage);
  console.log('=== CUSTOMIZER READY ===');
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    const btn = document.getElementById('open-customizer-btn');
    if (btn && !window.engravingCustomizer) {
      console.log('Auto-initializing on DOMContentLoaded');
    }
  });
}